module.exports = __webpack_public_path__ + "static/media/TMP3.dd99fc55.gif";